"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuildWealthMaxInvestmentsCheckBox = BuildWealthMaxInvestmentsCheckBox;
exports.EnsureFamilyFinanciallySecureGoalCheckBox = EnsureFamilyFinanciallySecureGoalCheckBox;
exports.PlanningRetirementGoalCheckBox = PlanningRetirementGoalCheckBox;
exports.SaveForEducationalExpensesGoalCheckBox = SaveForEducationalExpensesGoalCheckBox;
exports.SaveForMajorPurchaseGoalCheckBox = SaveForMajorPurchaseGoalCheckBox;
exports.TransitionWealthGoalCheckBox = TransitionWealthGoalCheckBox;
var _react = _interopRequireDefault(require("react"));
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import { Form, FormControl, InputGroup } from 'react-bootstrap'
// import formikMiddleware from '../../middleware/formikMiddleware'

function PlanningRetirementGoalCheckBox(props) {
  var {
    setFieldValue,
    isPlanningRetirementGoal
  } = props;
  var fieldName = 'planningRetirementGoalCheckBox';
  var name = 'planningForRetirementGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'PlanningForRetirementGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'isPlanningRetirementGoal');
      setFieldValue('isPlanningRetirementGoal', !isPlanningRetirementGoal);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "checkbox",
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isPlanningRetirementGoal
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "planningRetirementGoalCheckBox"
  }, "Plan for and live a comfortable retirement")))));
}
function TransitionWealthGoalCheckBox(props) {
  var {
    setFieldValue,
    isTransitioningWealthGoal
  } = props;
  var fieldName = 'transitionWealthGoalCheckBox';
  var name = 'transitionWealthGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'TransitionWealthGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'transitionWealthGoalCheckBox');
      setFieldValue('isTransitioningWealthGoal', !isTransitioningWealthGoal);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "checkbox",
    role: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isTransitioningWealthGoal
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "transitionWealthGoalCheckBox"
  }, "Transition wealth")))));
}
function SaveForMajorPurchaseGoalCheckBox(props) {
  var {
    setFieldValue,
    isSavingForMajorPurchaseGoal
  } = props;
  var fieldName = 'savingForMajorPurchaseGoalCheckBox';
  var name = 'savingForMajorPurchaseGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'SavingForMajorPurchaseGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'savingForMajorPurchaseGoalCheckBox');
      setFieldValue('isSavingForMajorPurchaseGoal', !isSavingForMajorPurchaseGoal);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "checkbox",
    role: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isSavingForMajorPurchaseGoal
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "savingForMajorPurchaseGoalCheckBox"
  }, "Save for a major purchase")))));
}
function BuildWealthMaxInvestmentsCheckBox(props) {
  var {
    setFieldValue,
    isBuildWealthGoal
  } = props;
  var fieldName = 'buildingWealthCheckBox';
  var name = 'buildingWealthCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'BuildingWealthCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'buildingWealthCheckBox');
      setFieldValue('isBuildWealthGoal', !isBuildWealthGoal);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "checkbox",
    role: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isBuildWealthGoal
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "buildingWealthCheckBox"
  }, "Build wealth/maximize my investments")))));
}
function SaveForEducationalExpensesGoalCheckBox(props) {
  var {
    setFieldValue,
    isSavingForEducationExpensesGoal
  } = props;
  var fieldName = 'savingForEducationalExpensesGoalCheckBox';
  var name = 'savingForEducationalExpensesGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'SavingForEducationalExpensesGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'savingForEducationalExpensesGoalCheckBox');
      setFieldValue('isSavingForEducationExpensesGoal', !isSavingForEducationExpensesGoal);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "checkbox",
    role: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isSavingForEducationExpensesGoal
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "savingForEducationalExpensesGoalCheckBox"
  }, "Save for educational expenses")))));
}
function EnsureFamilyFinanciallySecureGoalCheckBox(props) {
  var {
    setFieldValue,
    isFamilyFinanciallySecureGoal
  } = props;
  var fieldName = 'ensurefamilyfinanciallysecureGoalCheckBox';
  var name = 'ensurefamilyfinanciallysecureGoalCheckBox';
  var type = 'checkbox';
  var ariaLabel = 'EnsurefamilyfinanciallysecureGoalCheckBox';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-control custom-checkbox flex-grow-by-2",
    onClick: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'field_input', fieldName, 'ensurefamilyfinanciallysecureGoalCheckBox');
      setFieldValue('isFamilyFinanciallySecureGoal', !isFamilyFinanciallySecureGoal);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-required": "true",
    "aria-labelledby": "checkbox",
    role: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    "aria-label": ariaLabel,
    id: _FinancialPlanningCheckupWizardTool.idPrefix + fieldName,
    name: name,
    className: "custom-control-input",
    required: false,
    checked: isFamilyFinanciallySecureGoal
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "custom-control-label card-option-label",
    htmlFor: "ensurefamilyfinanciallysecureGoalCheckBox"
  }, "Ensure my family is financially secure")))));
}